import React from "react";

export default function AboutLinen() {
  return (
   <div className="hospitality-page">

          <div
        className="hospitality-hero"
        style={{ backgroundImage: "url(/about-hero.jpg)" }}
      >
        <div className="hospitality-hero-overlay">
          <h1>About Linen</h1>
        </div>
        </div>

          {/* Content Section */}
      <div className="hospitality-content container">
          

       <h3>DESCRIPTION ABOUT THE LINEN:</h3>
       <p>
        Linen is naturally made fibre from the flax plant (Linumusitatissimum). It is highly absorbable cloth which can absorb up to 20% of its own weight. 
There are many countries in the world those who Produce the raw material to produce linen, Russia being the highest cultivator with Western Europe & China producing substantial quantity. Other countries to cultivate are Italy, Egypt, Poland, France, Switzerland, India & Pakistan.

       </p>

<h3>DIFFERENCE BETWEEN COTTON AND LINEN:</h3>
<p>The difference between them based on their look, feel and properties.
Cotton does not conduct heat while linen are hollow which makes it very cool during summer.
Cotton can be stretched, and it is flexible unlike linen. Finer made cotton such as the Nile Cotton which is made from long staple fibers which makes it softer and mode durable than the regular cotton.
Cotton tend to be softer to touch as compared with the linen, when washed and taken proper cared for cotton sheets will last for more than 3 years before showing signs of wear and tear.
Both cotton and linen are hypoallergic; however, linen is slightly better for people with allergies as the lower thread count and the loose weave is less likely to trap and particles.
</p>
<h3>SIMILARITIES BETWEEN COTTON AND LINEN:</h3>
<p>Both of them are soft with comfortablity</p>
<p>Both of them are naturally formed fabrics</p>
<p>They have a high rate of breathability.</p>
<p>They are hypoallergic (Excellent to avoid Type 1 and Type 4 allergic reaction)</p>

<h3>MANUFACTURING OF LINEN:</h3>

<p>
    Extracting the linen fibres from the flax plant is a time-consuming process. To harvest the flax plants, they must be pulled from the ground rather than being cut to retain the full length of the fibre. After being harvested the plants are left in the field to soften to the point where bacteria and fungi become present. This allows the woody section to start decomposing and make it easier to separate the fibre. The fibre is collected from the plants and then rolled and stored in shelter for 2-3 months, where it continues to soften.
</p>
<p>
    The fibres are then combed to remove excess impurities and shorter fibres. The long fibres (used for bed linen) are slightly twisted and then processed using a ‘wet spinning’ technique to achieve a smoother and softer yarn. Alternatively, the short fibres are collected and spun together using a ‘dry spinning’ technique. This results in a stronger and heavier yarn which is ideal for heavy duty uses such as upholstery or heavy apparel fabrics.
</p>
<p>
    The linen yarns used for sheeting are carefully graded and sorted into different qualities ranging from the extremely fine (Como Linen) to a high standard of regular linen (Dublino and Citi Linen). Italian weaving mills select only the finest linen yarns to produce their fabrics with. It is in these Italian mills where generations of weaving mastery become apparent. The Italians are unmatched in their ability to weave and finish the finest fabrics in the world. The techniques used are safeguarded to ensure they cannot be copied.
</p>

<h3>BENEFITS OF LINEN:</h3>
<p>It can be washed and dried in a washing machine.</p>
<p>We can hand wash it.</p>
<p>Its bedding and clothes can be used in any kind of weather.</p>
<p>It shrinks and the shrinkage percent 4-5%.</p>


        
        </div>
      

</div>
  );
}
